// 实时爆料 · 编辑部内容数据
// 栏目
export const CHANNELS = [
  { id: "all", label: "全部焦点", desc: "全网热点一屏聚合" },
  { id: "society", label: "社会现场", desc: "民生热点与事件追踪" },
  { id: "tech", label: "科技前哨", desc: "产品发布与趋势观察" },
  { id: "market", label: "消费风向", desc: "价格行情与消费新动向" },
  { id: "life", label: "生活研究所", desc: "实用知识与生活指南" },
  { id: "culture", label: "文化娱乐", desc: "文娱动态与流行文化" },
];

export type NewsItem = {
  id: string;
  slug: string;
  channel: string;
  badge: string;
  title: string;
  excerpt: string;
  author: string;
  timeText: string;
  readMin: number;
  views: number;
  hot: boolean;
  urgent: boolean;
  cover: string;
  keywords: string[];
  content: string[];
};

export const NEWS: NewsItem[] = [
  {
    id: "n01",
    slug: "dianche-jiaquan-chongdianwang",
    channel: "market",
    badge: "热点追踪",
    title: "新能源汽车价格战进入下半场：多家厂商转向“价值竞争”",
    excerpt:
      "经历多轮价格下调后，新能源车企开始把竞争焦点从“谁更便宜”转向配置、补能与售后。多位行业观察人士指出，这一转变或将成为影响年末销量格局的关键变量。",
    author: "记者 陈舟",
    timeText: "刚刚",
    readMin: 6,
    views: 48620,
    hot: true,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=sleek%20modern%20electric%20vehicle%20charging%20at%20a%20futuristic%20station%20at%20dusk%2C%20warm%20ambient%20lighting%2C%20editorial%20automotive%20photography%2C%20cinematic%20tones%2C%20high%20detail&width=640&height=420&seq=news-evc-01&orientation=landscape",
    keywords: ["新能源汽车", "价格战", "行业观察", "市场行情"],
    content: [
      "过去一年里，几乎每个月都能看到新一轮降价消息。但随着部分车型价格已触及成本线，单纯依靠“以价换量”的空间正在收窄。近期多家头部厂商在发布会上把重点重新放回智能座舱、补能网络与用户权益，行业竞争的叙事正在悄悄改写。",
      "多位供应链人士向编辑部表示，电池材料价格已趋于平稳，车企有条件把更多资源投向长期体验而非短期让利。与此同时，置换补贴与渠道下沉仍是拉动销量的主要抓手，价格之外的比拼才刚刚开始。",
      "观察人士提醒，价值竞争不等于回到高定价时代，而是用更透明的配置、更可靠的售后与更低的拥车成本来赢得口碑。对于持币观望的消费者而言，当下需要关注的不仅是成交价，还有交付周期与充电便利度这些长期变量。",
      "后续我们也将持续追踪各品牌权益调整，为读者拆解每一轮价格与配置变动的真实含金量。",
    ],
  },
  {
    id: "n02",
    slug: "xianxia-jingji-renchaodizhoumo",
    channel: "life",
    badge: "现场直击",
    title: "“夜经济”持续升温：深夜档市集与小酒馆撑起城市新活力",
    excerpt:
      "从商圈夜市到街区里的深夜小酒馆，年轻人正在用脚投票，把原本属于白天的社交搬进了夜晚。多座城市的夜间消费客流在近期创下新高，背后的商业逻辑与治理细节同样值得关注。",
    author: "记者 苏禾",
    timeText: "12分钟前",
    readMin: 5,
    views: 35240,
    hot: true,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20night%20market%20stalls%20with%20warm%20string%20lights%20and%20street%20food%2C%20lively%20evening%20crowds%2C%20golden%20warm%20tones%2C%20editorial%20lifestyle%20photography%2C%20atmospheric%2C%20high%20detail&width=640&height=420&seq=news-night-02&orientation=landscape",
    keywords: ["夜经济", "深夜市集", "消费新动向", "城市活力"],
    content: [
      "晚上九点过后，不少城市的商圈非但没有安静下来，反而迎来一天里的第二波人流。以夜市市集、沉浸式演出和深夜咖啡为代表的业态，正在重塑人们对“下班后的时间”的想象。",
      "走访中，多位摊主提到，相比过去“卖个氛围”，现在的年轻消费者更在意品质与社交价值——愿意为有设计感的摊位、可分享的空间和真实的在地风味买单。这也倒逼经营者从选品到运营都更讲究。",
      "与此同时，延长交通运营、规范外摆经营等配套措施陆续落地，为夜经济提供了更稳妥的土壤。业内普遍认为，真正的竞争不是“开得有多晚”，而是能否把体验做成能让人反复回来的理由。",
    ],
  },
  {
    id: "n03",
    slug: "ai-dasuan-gerenbiaodian",
    channel: "tech",
    badge: "AI 观察",
    title: "端侧大模型走向个人设备：手机、笔记本开始“自带大脑”",
    excerpt:
      "无需联网、数据留在本地，端侧大模型的落地让隐私保护与智能体验不再二选一。随着新一代芯片量产，越来越多消费电子产品把“离线智能”作为主打卖点。",
    author: "记者 周野",
    timeText: "28分钟前",
    readMin: 7,
    views: 41880,
    hot: true,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20personal%20computer%20displaying%20abstract%20neural%20network%20glow%2C%20warm%20orange%20and%20ink%20tones%2C%20clean%20editorial%20tech%20photography%2C%20high%20detail%2C%20sophisticated&width=640&height=420&seq=news-ai-03&orientation=landscape",
    keywords: ["端侧AI", "大模型", "个人设备", "隐私计算"],
    content: [
      "过去两年，“大模型”几乎等于“云端调用”。而现在，一批能够完全在本地运行的轻量模型开始进入量产设备，从翻译、摘要到语音助手，越来越多操作不再需要把数据上传服务器。",
      "技术上的关键在于量化与剪枝让模型体积大幅缩小，加上新一代神经处理单元(NPU)算力的提升，个人电脑和旗舰手机得以在离线状态下完成此前难以想象的复杂任务。",
      "对普通用户而言，最直观的改变是隐私更可控、响应更及时，弱网环境下的体验也明显改善。不过业内人士也坦言，端侧能力的上限仍受限于设备算力，长远的趋势将是“云端协同、端侧兜底”。",
    ],
  },
  {
    id: "n04",
    slug: "cuoying-chazuo-nianqingxiaofei",
    channel: "market",
    badge: "趋势速报",
    title: "“情绪价值”成消费关键词：悦己型购物撑起千亿市场",
    excerpt:
      "解压玩具、香氛盲盒、情绪陪伴类服务……越来越多消费者愿意为一时的“被治愈”买单。情绪消费为何崛起，又该如何理性看待？我们与多位从业者聊了聊。",
    author: "编辑 老魏",
    timeText: "1小时前",
    readMin: 6,
    views: 29870,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20flatlay%20of%20scented%20candles%20stress%20relief%20toys%20and%20aroma%20bottles%20on%20warm%20paper%20background%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20gentle%20tone%2C%20high%20detail&width=640&height=420&seq=news-mood-04&orientation=landscape",
    keywords: ["情绪消费", "悦己经济", "解压", "消费趋势"],
    content: [
      "“买它不是因为需要，而是因为它让我开心。”这句话正在成为不少年轻消费者钱包里的隐形准则。从几十元的解压玩具到数百元的香氛与陪伴型服务，为情绪付费的现象越发普遍。",
      "从消费结构看，情绪消费并非简单的冲动消费。很多产品把功能价值与情感价值结合起来，用低门槛的定价满足高频的心理慰藉需求，因此即便在经济波动期也保持了韧性。",
      "业内专家同时提醒，情绪消费的本质是服务真实感受，商家若只靠营销话术制造焦虑，反而难以持久。对消费者而言，量入为出、把愉悦建立在真实产品力之上，才是更可持续的态度。",
    ],
  },
  {
    id: "n05",
    slug: "luyou-honghuang-qingmingchuxing",
    channel: "society",
    badge: "现场直击",
    title: "假期出行高峰提前到来：跨城通勤与“反向旅游”成新趋势",
    excerpt:
      "临近假期，铁路与民航预订量快速攀升。与此同时，避开热门景区、深入小城与乡村的“反向旅游”热度走高，为出行市场带来新的想象空间。",
    author: "记者 林默",
    timeText: "2小时前",
    readMin: 5,
    views: 37650,
    hot: true,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=modern%20high%20speed%20train%20crossing%20warm%20golden%20fields%20at%20sunset%2C%20editorial%20travel%20photography%2C%20serene%20atmosphere%2C%20high%20detail%2C%20cinematic%20light&width=640&height=420&seq=news-travel-05&orientation=landscape",
    keywords: ["假期出行", "反向旅游", "高铁", "旅游趋势"],
    content: [
      "从车票与机票的预订节奏看，今年出行高峰比往年提前了近一周。除了返乡客流，利用假期进行短途跨城游、高铁周边游的年轻人明显增多，让不少中型城市的酒店与餐饮订单同步走高。",
      "更值得注意的是“反向旅游”的流行——游客开始主动避开人挤人的头部景区，转而选择交通便利、性价比高且有在地特色的小城。这种变化既是消费理性的体现，也推动目的地运营从“拼名气”转向“拼体验”。",
      "交通部门提醒，热门方向的车票较为紧俏，建议错峰出行并留意天气变化；前往小城的游客则需提前确认景点开放时间与住宿条件，让旅行真正从容。",
    ],
  },
  {
    id: "n06",
    slug: "rujia-ai-shengji-zhuangbei",
    channel: "tech",
    badge: "前沿速报",
    title: "具身智能加速落地：人形机器人开始走进工厂与仓库",
    excerpt:
      "从实验室到产线，具身智能机器人的商业化拐点正在逼近。多位开发者表示，真正的价值不在“走得多稳”，而在能否在真实场景中稳定完成复杂任务。",
    author: "记者 周野",
    timeText: "3小时前",
    readMin: 7,
    views: 26430,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=humanoid%20robot%20working%20alongside%20humans%20in%20a%20modern%20warmly%20lit%20factory%2C%20editorial%20industrial%20photography%2C%20soft%20warm%20tones%2C%20high%20detail%2C%20cinematic&width=640&height=420&seq=news-robot-06&orientation=landscape",
    keywords: ["具身智能", "人形机器人", "智能制造", "机器人"],
    content: [
      "在人形机器人热度不断攀升的当下，行业正把关注点从“会跳舞、能对话”的演示，转向能稳定完成搬运、质检等任务的真实落地。多家厂商已与制造、仓储企业签署试点合作。",
      "技术门槛在于感知、运动控制与任务的复杂组合。一位开发者告诉编辑部，看似简单的“抓取一件规格不一的货物”，背后需要视觉、力觉与规划算法的高度协同，而这正是从“能走”到“能用”的关键一跃。",
      "从产业周期看，具身智能仍处于早期，规模商用还有赖于成本下降与场景验证。但可以确定的是，机器人不再只是展台明星，而正逐步成为流水线上被认真考核的“新员工”。",
    ],
  },
  {
    id: "n07",
    slug: "shengxian-shicai-jiage-dongtai",
    channel: "market",
    badge: "行情简报",
    title: "本地生鲜价格平稳回落：供应充足带动菜篮子“降温”",
    excerpt:
      "随着天气回暖与本地供应放量，近期多地菜篮子价格出现明显回落。记者走访多个农贸市场，为读者梳理当前主要品类的价格变化与选购建议。",
    author: "记者 苏禾",
    timeText: "4小时前",
    readMin: 4,
    views: 19850,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=fresh%20vegetables%20and%20fruits%20arranged%20at%20a%20warm%20local%20farmers%20market%2C%20natural%20morning%20light%2C%20editorial%20food%20photography%2C%20vibrant%20yet%20natural%20tones%2C%20high%20detail&width=640&height=420&seq=news-veg-07&orientation=landscape",
    keywords: ["菜篮子", "生鲜价格", "市场行情", "农产品"],
    content: [
      "清晨的农贸市场里，摊主们的标价牌正在悄然变化。连续一周的监测显示，叶菜、瓜果类价格较上旬普遍回落，部分当季蔬菜的价格降幅超过一成，猪肉等肉类价格则保持平稳。",
      "价格回落的直接原因是供应端的改善——气温回升加快了本地大棚蔬菜的上市节奏，叠加物流通畅，批发市场的到货量稳步增加。多位批发商预计，短期内菜价将维持温和态势。",
      "对家庭来说，当前正是按需囤储当季菜的好时机。建议优先选择产地近、损耗小的品类，既保证新鲜，也能把实惠落到实处。",
    ],
  },
  {
    id: "n08",
    slug: "shoumian-zhongyi-guojiare",
    channel: "life",
    badge: "生活指南",
    title: "换季养生正当时：从“春捂”到睡眠的实用清单",
    excerpt:
      "昼夜温差大、流感高发，换季时节的健康管理更要讲究方法。我们从饮食、起居与运动三方面，整理了一份普通人就能上手的换季养生清单。",
    author: "编辑 老魏",
    timeText: "5小时前",
    readMin: 5,
    views: 24170,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=calm%20wellness%20scene%20with%20herbal%20tea%20warm%20blanket%20and%20soft%20morning%20light%20by%20window%2C%20editorial%20lifestyle%20photography%2C%20gentle%20warm%20tone%2C%20high%20detail&width=640&height=420&seq=news-health-08&orientation=landscape",
    keywords: ["换季养生", "健康指南", "睡眠", "春季饮食"],
    content: [
      "换季时节，最大的健康考验往往来自“温差”与“作息错位”。白天温暖、早晚偏凉，如果不注意增减衣物，很容易给病毒留下可乘之机，这也是“春捂”说法的由来。",
      "饮食上，建议少食生冷、多补充时令果蔬，并适当摄入优质蛋白以增强抵抗力；作息上，尽量固定入睡与起床时间，避免因气温回升而熬夜贪凉。运动则以温和的有氧为主，循序渐进。",
      "专家特别提醒，若出现持续发热、明显乏力等症状，应尽早就医，不要凭经验自行用药。健康管理讲究长期主义，把好习惯落进日常生活，远比临时补救更有效。",
    ],
  },
  {
    id: "n09",
    slug: "chuanmei-xuanchuan-guibao",
    channel: "society",
    badge: "权威提醒",
    title: "识破“高收益”话术：警惕披着理财外衣的新型骗局",
    excerpt:
      "“稳赚不赔”“内部渠道”……近期多地出现新型投资骗局，利用人们对收益的期待步步设套。警方与消协发布提醒，编辑部为你拆解常见套路与防骗要点。",
    author: "记者 林默",
    timeText: "6小时前",
    readMin: 6,
    views: 51280,
    hot: true,
    urgent: true,
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20image%20of%20a%20padlock%20and%20shield%20over%20financial%20charts%20with%20warning%20red%20accents%2C%20clean%20editorial%20finance%20photography%2C%20high%20detail%2C%20dramatic%20yet%20clear&width=640&height=420&seq=news-scam-09&orientation=landscape",
    keywords: ["反诈", "投资骗局", "金融安全", "防骗指南"],
    content: [
      "近年来，以“高收益”“稳赚不赔”为诱饵的骗局不断翻新花样：有人冒充正规理财平台客服，有人以“内幕消息群”引流，还有人打着元宇宙、数字藏品等概念包装虚假项目。",
      "尽管话术不同，骗局的底层逻辑却高度相似——先用小额返利建立信任，再诱导加大投入，最后在提现环节设置障碍甚至卷款消失。识别关键点其实很简单：承诺“保本高息”的项目几乎都可以判定为高风险甚至虚假。",
      "警方与消协提醒广大市民，投资前务必核实平台资质，选择持牌金融机构，切勿向陌生账户直接转账。若不慎受骗，请第一时间保存转账记录并拨打报警电话，为追回损失争取时间。",
      "我们也提醒，任何“稳赚”的说法都值得警惕，理财没有捷径，安全永远排在收益之前。",
    ],
  },
  {
    id: "n10",
    slug: "hecha-yinliao-wuxing-baijia",
    channel: "culture",
    badge: "潮流观察",
    title: "无糖与低因并行：健康化浪潮下的饮料新赛道",
    excerpt:
      "从无糖气泡水到低因茶饮，年轻人对“喝得轻松”的需求，正在推动整个饮料行业重写配方逻辑。哪些新品类正在快速起量？编辑部做了梳理。",
    author: "编辑 苏禾",
    timeText: "7小时前",
    readMin: 4,
    views: 18640,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=refreshing%20sugar%20free%20and%20herbal%20drinks%20in%20modern%20glass%20bottles%20with%20citrus%20on%20warm%20minimal%20background%2C%20editorial%20beverage%20photography%2C%20bright%20natural%20tone%2C%20high%20detail&width=640&height=420&seq=news-drink-10&orientation=landscape",
    keywords: ["无糖饮料", "低因茶饮", "饮品趋势", "健康消费"],
    content: [
      "货架上的饮料越来越“卷”的不只是口味，还有成分表。前几年跑出来的无糖气泡水带动了整个品类的迭代，如今“低因”“植物基”“真果汁”等更细分标签也开始成为卖点。",
      "这一变化的背后是消费者对健康的细致化理解：不再满足于“少糖”，还要关心咖啡因、添加物与原料来源。品牌方则顺势把“配料表干净”变成一种沟通语言。",
      "业内人士判断，健康化不是一时风口，而是会持续作用于配方、包装与渠道的长期命题。对消费者而言，看懂配料表、按需选择，才能真正喝得安心又轻松。",
    ],
  },
  {
    id: "n11",
    slug: "luqi-duanju-chunfengban",
    channel: "culture",
    badge: "文娱速递",
    title: "短剧市场迎来“品质分水岭”：从量到质的转向已开始",
    excerpt:
      "经历了爆发式增长后，短剧行业正在告别粗放生产。精品化、分众化与出海成为关键词，从业者如何应对新一轮洗牌？",
    author: "记者 周野",
    timeText: "8小时前",
    readMin: 6,
    views: 22130,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20film%20set%20with%20spotlight%20and%20cinema%20camera%20in%20warm%20glow%2C%20editorial%20entertainment%20industry%20photography%2C%20cinematic%2C%20high%20detail%2C%20atmospheric&width=640&height=420&seq=news-drama-11&orientation=landscape",
    keywords: ["短剧", "微短剧", "内容行业", "出海"],
    content: [
      "过去一年，短剧赛道完成了一场从“野蛮生长”到“规范化”的急转弯。随着内容审核趋严与投放成本走高，单纯依赖套路化剧本和流量投放的模式明显降温。",
      "取而代之的是制作水准更精良、题材更多元的作品，部分优质短剧甚至反向出圈，带动了长视频与出版等周边链条。与此同时，短剧出海成为行业新增长点，中文叙事的本土化改编正积累经验。",
      "在编辑部看来，短剧真正的机会在于用“轻形态”讲“重内容”。谁能把情感浓度、叙事效率与商业回报平衡好，谁就能在这轮洗牌中走得更远。",
    ],
  },
  {
    id: "n12",
    slug: "chaishi-zhoubian-hanpao-re",
    channel: "market",
    badge: "消费观察",
    title: "“含跑量”成新指标：跑步装备从功能刚需卷到情绪表达",
    excerpt:
      "当跑步成为一种生活方式，跑鞋、手表与穿搭早已不只是装备。品牌围绕“城市跑者”的竞争，正在从参数比拼转向社群与身份认同。",
    author: "记者 陈舟",
    timeText: "9小时前",
    readMin: 5,
    views: 17350,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=runners%20crossing%20a%20city%20street%20at%20golden%20hour%20wearing%20modern%20athletic%20gear%2C%20editorial%20sport%20photography%2C%20dynamic%2C%20warm%20tones%2C%20high%20detail&width=640&height=420&seq=news-run-12&orientation=landscape",
    keywords: ["跑步经济", "运动装备", "城市跑者", "消费趋势"],
    content: [
      "清晨与傍晚的城市绿道，跑步人群明显壮大。随之而来的，是运动鞋服、运动手表乃至跑步社群周边产品的同步升温，“含跑量”甚至成为部分社交圈里的新型谈资。",
      "与过去追求“专业参数天花板”不同，新一代跑者的装备逻辑更务实：轻量缓震、适合城市通勤、外观能日常出街——功能与审美的平衡点成为购买决策的关键。",
      "品牌们则顺势把线下社群与线上赛事玩成“养成系”，通过陪伴式运营强化用户黏性。当跑步从自律变成生活方式，商业化的想象空间也随之被打开。",
    ],
  },
  {
    id: "n13",
    slug: "shijian-liqi-jinengpeixun",
    channel: "society",
    badge: "深度追踪",
    title: "“学点用得上的”：职业技能培训热背后的真实需求",
    excerpt:
      "考公热、编程班、副业课……面对不确定的职场，越来越多人把注意力投向“硬技能”。培训机构火热的背后，哪些需求是真实的，哪些话术又需要冷静看待？",
    author: "记者 林默",
    timeText: "10小时前",
    readMin: 7,
    views: 28990,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=people%20attending%20a%20focused%20evening%20coding%20and%20skills%20workshop%20in%20a%20warm%20lit%20modern%20classroom%2C%20editorial%20photography%2C%20high%20detail%2C%20soft%20warm%20tones&width=640&height=420&seq=news-skill-13&orientation=landscape",
    keywords: ["职业技能", "就业", "培训", "职场充电"],
    content: [
      "今年以来，围绕“技能变现”的付费学习明显回温。从面向转岗人群的编程训练营，到针对全职家长的图文与运营副业课，市场似乎嗅到了新的增长点。",
      "但热闹之下也需要冷静。多位过来人坦言，多数培训的核心价值是提供体系化的路径与督促，真正决定成败的仍是个人持续投入。培训机构在宣传时也容易出现“焦虑营销”，把个例包装成普遍结果。",
      "编辑部建议，选择课程前不妨先回答三个问题：它能否补齐我的真实短板？投入产出周期是否匹配我的现状？机构是否有可核实的真实案例？把期待放平，学习这件事才不容易踩坑。",
    ],
  },
  {
    id: "n14",
    slug: "kuaidi-sushou-zhan-zhuangqian",
    channel: "life",
    badge: "实用问答",
    title: "新家入住倒计时：装修验收最容易忽略的五个细节",
    excerpt:
      "装完不等于住得安心。插座高度、防水闭水、门窗密封……这些验收中不起眼却影响日常的细节，往往最容易被忽略。我们整理了最容易踩坑的清单。",
    author: "编辑 老魏",
    timeText: "11小时前",
    readMin: 6,
    views: 20760,
    hot: false,
    urgent: false,
    cover:
      "https://readdy.ai/api/search-image?query=modern%20minimal%20interior%20being%20inspected%20by%20homeowner%20with%20tape%20measure%20and%20checklist%2C%20warm%20natural%20light%2C%20editorial%20home%20photography%2C%20high%20detail&width=640&height=420&seq=news-home-14&orientation=landscape",
    keywords: ["装修验收", "家装", "新房", "入住指南"],
    content: [
      "验收是新家交付前最重要的一关，但很多第一次装修的业主往往被“整体看着不错”误导，忽略了藏在角落里的隐患。这些细节看似小，入住后却可能变成大麻烦。",
      "首先是排水与防水：验收时务必做闭水试验，观察楼下是否渗水；其次是电路点位，建议逐一通电测试，并确认插座高度符合日常使用习惯，避免日后返工。",
      "此外，门窗的密封性、瓷砖的空鼓率、地漏的排水速度也值得重点检查。建议业主带着纸笔逐项核对，必要时请第三方机构做一次环保与结构复检，让“拎包入住”真正安心。",
    ],
  },
  {
    id: "n15",
    slug: "zhangbei-tongyong-paomo",
    channel: "society",
    badge: "热点追踪",
    title: "数据安全再敲警钟：个人信息“隐形交易”亟待遏制",
    excerpt:
      "骚扰电话为何精准到令人发指？一条条被非法收集的个人信息，正在黑产链条中明码标价。监管部门持续加大打击力度，普通人也需掌握必要的自保手段。",
    author: "记者 苏禾",
    timeText: "13小时前",
    readMin: 6,
    views: 33590,
    hot: true,
    urgent: true,
    cover:
      "https://readdy.ai/api/search-image?query=conceptual%20digital%20privacy%20illustration%20of%20shield%20and%20fingerprint%20over%20data%20streams%20in%20warm%20ink%20tones%2C%20editorial%2C%20high%20detail%2C%20crisp%20and%20clear&width=640&height=420&seq=news-data-15&orientation=landscape",
    keywords: ["个人信息保护", "数据安全", "反诈", "隐私"],
    content: [
      "“为什么我刚聊过的话题，转头就在购物App里出现？”这既是玩笑，也折射出个人信息在灰色地带流通的现实。从营销短信到精准诈骗，其源头往往都指向数据泄露。",
      "监管部门近期集中通报了一批违规收集、买卖个人信息的典型案例，明确要求App与平台履行告知义务，严禁超范围索取权限。技术手段之外，制度层面的紧箍也在越收越紧。",
      "对个人而言，养成几个小习惯能显著降低风险：非必要不授权相册与通讯录、慎连陌生公共Wi-Fi、对“点击领取”类链接保持警惕、定期查看并清理第三方授权。数据是自己的，守住入口才能真正安心。",
    ],
  },
];

// 滚动快讯（报头跑马灯 + 实时时间线）
export const FLASHES: string[] = [
  "新能源车企集体转向价值竞争，新一轮购车权益清单陆续公布",
  "全国多地菜篮子价格明显回落，当季蔬菜供应充足",
  "反诈中心发布新型投资骗局提示：警惕“内部渠道”话术",
  "端侧大模型进入量产设备，多款新品主打离线智能",
  "假期出行高峰提前，热门方向车票趋于紧俏",
  "无糖与低因并行，健康化浪潮重塑饮料货架",
  "夜经济持续升温，深夜市集与夜间演出客流走高",
  "监管部门通报多起个人信息违规收集典型案例",
];

// 实时时间线（右侧滚动）
export const LIVE_FEED = [
  { time: "刚刚", text: "更新：n01 新能源车价值竞争引发评论区热议，已补充厂商回应", tag: "更新" },
  { time: "18分钟前", text: "突发：某品牌发布智能眼镜新品，支持端侧翻译，即日开启预售", tag: "快讯" },
  { time: "42分钟前", text: "追踪：n09 反诈提醒被多地警方官方账号转载，阅读量破五万", tag: "扩散" },
  { time: "1小时前", text: "更新：夜经济观察补充城市交通延时运营信息", tag: "更新" },
  { time: "2小时前", text: "快讯：假期出行高峰提前，铁路部门增加临客班次", tag: "快讯" },
  { time: "3小时前", text: "数据：情绪消费话题登上热议榜，相关讨论量超千万", tag: "数据" },
  { time: "4小时前", text: "更正：n10 饮品稿件补充低因茶饮细分数据", tag: "更新" },
  { time: "5小时前", text: "快讯：具身智能厂商公布产线试点合作进展", tag: "快讯" },
];

// 热搜榜
export const HOT_RANK = [
  { id: "n09", title: "新型投资骗局套路拆解，警惕高收益话术" },
  { id: "n01", title: "新能源车价格战进入下半场" },
  { id: "n15", title: "个人信息“隐形交易”亟需遏制" },
  { id: "n05", title: "“反向旅游”成假期出行新趋势" },
  { id: "n02", title: "夜经济升温，深夜市集人气旺" },
  { id: "n03", title: "端侧大模型走进个人设备" },
  { id: "n04", title: "情绪消费撑起千亿市场" },
];

// 热门搜索词
export const HOT_KEYWORDS = [
  "新能源汽车",
  "端侧AI",
  "反诈提醒",
  "夜经济",
  "反向旅游",
  "菜篮子价格",
  "情绪消费",
  "短剧出海",
];

// FAQ
export const FAQS = [
  {
    q: "实时爆料的新闻来源是什么？如何保证消息可靠？",
    a: "我们聚合并交叉核验来自权威媒体、机构发布与多方信源的信息，所有内容经编辑部人工审核后发布。对于突发与紧急消息，我们会明确标注“快讯”状态并在核实后持续更新，标注“追踪”的内容则表示事件仍在跟进中。",
  },
  {
    q: "“实时爆料”与普通资讯网站有什么区别？",
    a: "核心在于“时效”与“追踪”。我们以滚动时间线的形式持续更新同一事件的最新进展，让你不必反复刷新或拼凑信息，就能在一处看到事件从发生到发酵的全貌。快讯、更新、更正等状态也一目了然。",
  },
  {
    q: "遇到不实信息或标题夸大，我可以反馈吗？",
    a: "完全可以。我们鼓励读者通过页面底部的“线索征集”表单提交纠错建议或提供新的新闻线索。编辑部会在核实后第一时间修订并公开更正记录，确保信息准确、可信。",
  },
  {
    q: "我关注的话题没出现在热榜上，如何第一时间看到？",
    a: "你可以在页面“焦点速递”区切换不同栏目，并按需使用顶部搜索框检索关键词。我们也会根据搜索与讨论热度动态调整栏目排序，让真正被关注的话题获得更好的曝光。",
  },
  {
    q: "实时爆料会转载付费或版权不明的图文内容吗？",
    a: "不会。我们坚持原创采编与合规授权转载并重，所有图片与稿件均标注来源，尊重原创版权。转载内容会在文内注明出处，避免任何未授权的使用。",
  },
  {
    q: "这些“快讯”是否已经过最终核实？",
    a: "标注“快讯”的内容我们已基于可靠信源完成初步核实并即时发布，但因事件仍在演进，后续若出现新信息或口径调整，我们会以“更新/更正”标签在时间线中及时说明，请以最新状态为准。",
  },
];

// 编辑部理念
export const EDITORIAL_NOTES = [
  {
    title: "时效优先",
    desc: "以分钟为单位追踪全网动向，把“刚刚发生”第一时间带到你面前。",
    icon: "ri-flashlight-fill",
  },
  {
    title: "交叉核验",
    desc: "单一信源不上头条，多方交叉比对后才推向读者。",
    icon: "ri-shield-check-line",
  },
  {
    title: "尊重版权",
    desc: "原创优先、合规转载，标注每一个信息来源。",
    icon: "ri-copyright-line",
  },
  {
    title: "持续追踪",
    desc: "热点不是一次性的，用滚动更新陪你把一件事看完整。",
    icon: "ri-refresh-line",
  },
];